import React from 'react';
import { Place } from '@/types';
import { ProcessedMetrics } from '@/types';
import { snapshot_Dashboard as SnapshotDashboard } from './snapshot_Dashboard';

interface JurisdictionSnapshotSectionProps {
  selectedPlace: Place;
  displayName: string;
  peerPlaces: Place[];
  metricsData: {
    selectedPlaceMetrics: ProcessedMetrics[];
    peerMetrics: { peer: Place; data: ProcessedMetrics[] }[];
    loading: boolean;
    error: string | null;
  };
}

export const JurisdictionSnapshotSection: React.FC<JurisdictionSnapshotSectionProps> = ({
  selectedPlace,
  displayName,
  peerPlaces,
  metricsData
}) => {
  if (metricsData.loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <p>Loading metrics...</p>
      </div>
    );
  }

  if (metricsData.error) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <p className="text-red-500">Error: {metricsData.error}</p>
      </div>
    );
  }

  return (
    <SnapshotDashboard
      selectedPlace={selectedPlace}
      selectedPlaceMetrics={metricsData.selectedPlaceMetrics}
      peerMetrics={metricsData.peerMetrics}
    />
  );
}; 